import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { TeamDashboardPageComponent } from "./team-dashboard-page.component";

export const teamDashboardPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-team-dashboard-page", TeamDashboardPageComponent)
    .atOrganisationUrl("/team/:teamId/dashboard")
    .reloadOnSearch(false)
    .build();
